import { useTranslate } from '@festina-life/ui/hooks'
import cx from 'classnames'

import { Attribute } from '../attribute/Attribute'

type Props = {
  size?: 'small' | 'normal'
}

export const DraftIndicator = ({ size = 'normal' }: Props) => {
  const translate = useTranslate()

  return (
    <Attribute
      isFaded={false}
      className={cx(
        'font-medium uppercase bg-draft-600 dark:bg-draft-400 text-amaze-inkBright',
        {
          'text-xs': size === 'small',
          'py-1 text-sm': size === 'normal',
        },
      )}
    >
      {translate('templateViewer.draftIndicator')}
    </Attribute>
  )
}
